import React, { memo } from 'react';
import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

function Show({ connector, onClick, connected, setupRequired }) {
  const theme = useTheme();
  const scopeCount =
    typeof connector?.scope === 'string'
      ? connector.scope
          .split(connector.scope.includes(',') ? ',' : /\s+/)
          .filter(Boolean).length
      : 0;

  return (
    <Tooltip title={connector?.name || ''}>
      <Box
        component="button"
        type="button"
        onClick={onClick}
        sx={{
          width: '100%',
          minHeight: 142,
          borderRadius: '14px',
          border: `1px solid ${theme.palette.divider}`,
          background: '#fffefa',
          color: '#253e34',
          px: 2.5,
          py: 2.5,
          display: 'flex',
          alignItems: 'center',
          gap: 1.25,
          textAlign: 'left',
          cursor: 'pointer',
          transition: 'transform 160ms ease, box-shadow 160ms ease',
          userSelect: 'none',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 18px rgba(16, 24, 40, 0.12)',
            borderColor: theme.palette.primary.main,
          },
        }}
      >
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: 2,
            backgroundColor: 'rgba(255,255,255,0.75)',
            border: `1px solid ${theme.palette.divider}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          {connector?.svg ? (
            <img
              alt={connector?.name || 'Connector'}
              style={{
                ...theme.custom.connectorSvg,
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
              src={`data:image/svg+xml;utf8,${encodeURIComponent(
                connector.svg
              )}`}
            />
          ) : (
            <Typography variant="caption">No Icon</Typography>
          )}
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 600,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
            }}
          >
            {connector?.name}
          </Typography>
          {typeof connected === 'boolean' && (
            <span
              className={`integration-connection-state ${
                connected ? 'is-connected' : ''
              }`}
            >
              {setupRequired
                ? '○ Setup incomplete — reconnect'
                : connected
                ? '● Connected'
                : '○ Not connected'}
            </span>
          )}
          {scopeCount > 0 && (
            <Chip
              label={`${scopeCount} permissions available`}
              size="small"
              sx={{ mt: 0.75, height: 22, fontSize: 11 }}
            />
          )}
        </Box>
      </Box>
    </Tooltip>
  );
}

export default memo(Show);
